import { Skill } from "@/domains/notification/constants/skill";

export const skillTranslate: Record<Skill, string> = {
  [Skill.Lungs]: "notification.lungVolume",
};
